import VuexPersistence from 'vuex-persist';
import { STORAGE_VUEX_ARTIST_STOCK_METADATA_IMPORT_KEY } from '@/artist.constants.js';

export default new VuexPersistence({
  // key: 'ME:artist:metadataImport',
  key: STORAGE_VUEX_ARTIST_STOCK_METADATA_IMPORT_KEY,
  storage: window.sessionStorage,
  modules: ['artistMetadataImport'],
});
